import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Please add values for the alert", -1 /* HOISTED */)
const _hoisted_2 = { class: "label column q-mb-md" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" * Type of impact ")
const _hoisted_4 = { class: "label column q-mb-md" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Actions and comments ")
const _hoisted_6 = { class: "label column q-mt-sm" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Estimated avoided downtime ")
const _hoisted_8 = { class: "row q-mb-md" }
const _hoisted_9 = { class: "col-4 q-mr-sm" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Estimated MAP (bbl)", -1 /* HOISTED */)
const _hoisted_11 = { class: "col-4 q-mr-sm" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Estimated MAI (bbl)", -1 /* HOISTED */)
const _hoisted_13 = { class: "col" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Estimated flaring (Mscf)", -1 /* HOISTED */)
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-4 q-mr-sm" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Estimated cost (dollars)", -1 /* HOISTED */)
const _hoisted_18 = { class: "col-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Estimated GHG (ton CO2eq)", -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Validate", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.getDisplayRealAlertPopin,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.getDisplayRealAlertPopin) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { style: {"width":"600px","max-width":"100vw","overflow":"auto","overflow-x":"hidden"} }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row items-center q-pb-none" }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_q_space),
              _createVNode(_component_q_btn, {
                icon: "close",
                flat: "",
                round: "",
                dense: "",
                "data-test": "button-close",
                onClick: _ctx.onClose
              }, null, 8 /* PROPS */, ["onClick"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                class: "column",
                onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent","stop"]))
              }, [
                _createElementVNode("span", _hoisted_2, [
                  _hoisted_3,
                  _createVNode(_component_q_select, {
                    modelValue: _ctx.selectedImpactType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedImpactType) = $event)),
                    options: _ctx.impactTypesOptions,
                    class: "q-mt-md main-dropdown-100",
                    "bg-color": "white",
                    borderless: "",
                    "input-style": {
                fontFamily: 'Roboto',
                fontSize: '14px',
                lineHeight: '14px',
              },
                    outlined: "",
                    "use-chips": "",
                    multiple: "",
                    "option-label": "label",
                    "option-value": "value",
                    "map-options": "",
                    "emit-value": "",
                    dense: ""
                  }, null, 8 /* PROPS */, ["modelValue", "options"])
                ]),
                _createElementVNode("span", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_q_input, {
                    modelValue: _ctx.actionsComments,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.actionsComments) = $event)),
                    type: "textarea",
                    rows: "3",
                    outlined: "",
                    dense: ""
                  }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _createElementVNode("span", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_q_select, {
                    modelValue: _ctx.selectedEstimatedAvoidedShutdown,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedEstimatedAvoidedShutdown) = $event)),
                    options: _ctx.estimatedAvoidedShutdownOptions,
                    "option-label": "label",
                    "option-value": "value",
                    standout: "",
                    "map-options": "",
                    "emit-value": "",
                    "bottom-slots": "",
                    class: "q-mt-md main-dropdown-100",
                    "bg-color": "white",
                    borderless: "",
                    "input-style": {
                fontFamily: 'Roboto',
                fontSize: '12px',
                lineHeight: '16px',
              },
                    outlined: "",
                    dense: ""
                  }, null, 8 /* PROPS */, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.estimatedMap,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.estimatedMap) = $event)),
                      class: "estimated",
                      outlined: "",
                      type: "number",
                      dense: ""
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.estimatedMai,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.estimatedMai) = $event)),
                      class: "estimated",
                      outlined: "",
                      type: "number",
                      dense: ""
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.estimatedFlaring,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.estimatedFlaring) = $event)),
                      class: "estimated",
                      outlined: "",
                      type: "number",
                      dense: ""
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.estimatedCost,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.estimatedCost) = $event)),
                      class: "estimated",
                      outlined: "",
                      type: "number",
                      dense: ""
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.estimatedGhg,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.estimatedGhg) = $event)),
                      class: "estimated",
                      outlined: "",
                      type: "number",
                      dense: ""
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ])
                ]),
                _createVNode(_component_q_card_actions, { align: "right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      outline: "",
                      rounded: "",
                      "no-caps": "",
                      class: "action-button",
                      type: "submit"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ], 32 /* HYDRATE_EVENTS */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}